var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPinned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.777 25.6L34.5769 29.0653V31.3345H25.1347V42.3652L24.0001 43.4998L22.8655 42.3652V31.3345H13.4233V29.0653L17.0002 25.6V9.2692H14.6348V7H33.1424V9.2692H30.777V25.6ZM16.4925 29.0653H31.2847L28.5078 26.4307V9.2692H19.2694V26.4307L16.4925 29.0653Z",
    fill: "#3E4AE7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinned);
export default __webpack_public_path__ + "static/media/pinned.63dc65582756e4d7bfc64d50cea4d660.svg";
export { ForwardRef as ReactComponent };